import React from "react";

export default function BulletedListIcon(props) {
  return (
    <svg height={40} viewBox="0 0 24 24" width={17} {...props}>
      <path
        fill="currentColor"
        d="M2.5 7C1.121 7 0 5.879 0 4.5S1.121 2 2.5 2 5 3.121 5 4.5 3.879 7 2.5 7zm0-4C1.673 3 1 3.673 1 4.5S1.673 6 2.5 6 4 5.327 4 4.5 3.327 3 2.5 3zM2.5 15C1.121 15 0 13.879 0 12.5S1.121 10 2.5 10 5 11.121 5 12.5 3.879 15 2.5 15zm0-4c-.827 0-1.5.673-1.5 1.5S1.673 14 2.5 14 4 13.327 4 12.5 3.327 11 2.5 11zM2.5 23C1.121 23 0 21.879 0 20.5S1.121 18 2.5 18 5 19.121 5 20.5 3.879 23 2.5 23zm0-4c-.827 0-1.5.673-1.5 1.5S1.673 22 2.5 22 4 21.327 4 20.5 3.327 19 2.5 19zM23.5 5h-16a.5.5 0 010-1h16a.5.5 0 010 1zM23.5 13h-16a.5.5 0 010-1h16a.5.5 0 010 1zM23.5 21h-16a.5.5 0 010-1h16a.5.5 0 010 1z"
      />
    </svg>
  );
}
